import React, { useCallback, useEffect, useState } from 'react';
import { text } from '../../../../utils/text';
import { Card, CardHeader } from '../../../common/Card/Card';
import { scenarioSteps, trackScenario } from '../../../../tracking';
import { Layout } from '../../../common/Layout/Layout';
import { Action, AnswerState, FatcaQuestionKey, RoutePath } from '../../../../utils/types';
import { Redirect, useHistory } from 'react-router-dom';
import { useFormContext } from '../../../../context/FormContext';
import { NavigationButtons } from '../../../common/NavigationButtons/NavigationButtons';
import { flatMapAnswers, RaadgivningForm, RaadgivningInput, } from '@gjensidige/gpf-raadgivning-form';
import { Spacer } from '../../../common/Spacer/Spacer';
import { flattenGroupedQuestions } from '../../../../utils/utils';
import { Text, Title } from '@gjensidige/core-typography';
import styles from './raadgivning.module.less';
import { hasOtherTaxRelation, TaxRelationSection } from './TaxRelationSection';
import { SecondaryButton } from '@gjensidige/core-buttons';
import { Edit } from '@gjensidige/core-icons';
import { AutomatiskeProsesserModal } from '../../../common/AutomatiskeProsesserModal/AutomatiskeProsesserModal';
import utils from '@gjensidige/core-utilities-css';
export const FatcaForm = () => {
    var _a, _b;
    const [{ kontoopplysninger, raadgivningData }, dispatch] = useFormContext();
    const [showModal, setShowModal] = useState(false);
    const questionGroups = (_b = (_a = raadgivningData === null || raadgivningData === void 0 ? void 0 : raadgivningData.fatca) === null || _a === void 0 ? void 0 : _a.groups) !== null && _b !== void 0 ? _b : [];
    const history = useHistory();
    useEffect(() => {
        trackScenario(scenarioSteps.RAADGIVNING_FATCA);
    }, []);
    const dispatchAnswers = useCallback((answers) => {
        dispatch({
            type: Action.SUBMIT_RAADGIVNING_DATA,
            raadgivningData: Object.assign(Object.assign({}, raadgivningData), { fatca: Object.assign(Object.assign({}, raadgivningData.fatca), { answers }) }),
        });
    }, [dispatch, raadgivningData]);
    if (!kontoopplysninger.spareformål)
        return React.createElement(Redirect, { to: RoutePath.KONTO });
    if (!raadgivningData.ref || !raadgivningData.type)
        return React.createElement(Redirect, { to: RoutePath.RAADGIVNING_EGNETHET });
    const submit = (answers) => {
        dispatchAnswers(answers);
        history.push(RoutePath.SUMMARY);
    };
    const isBasedOnPreviousRaadigvning = raadgivningData.fatca.initialAnswerState === AnswerState.ANSWERED;
    return (React.createElement(Layout, { title: text.LAYOUT.START_SAVING.TITLE.no },
        React.createElement(Card, { step: 5 },
            React.createElement(RaadgivningForm, { questions: flattenGroupedQuestions(questionGroups), onSubmit: (answers) => submit(answers), initialAnswers: raadgivningData.fatca.answers }, (control, answers, updateAnswer) => (React.createElement(Spacer, { child: 'lg' },
                isBasedOnPreviousRaadigvning && (React.createElement(CardHeader, { title: text.FORM.RAADGIVNING_FATCA.PREV_ANSWERS_TITLE.no, subtitle: text.FORM.RAADGIVNING_FATCA.PREV_ANSWERS_DESCRIPTION.no })),
                sortGroupsByPriority(questionGroups).map((group) => (React.createElement(QuestionSection, { key: group.key, label: group.label, description: group.description, questions: group.questions, control: control, answers: answers, updateAnswer: updateAnswer, initialAnswerState: raadgivningData.fatca.initialAnswerState }))),
                React.createElement(SecondaryButton, { onClick: () => setShowModal(true), noPadding: true, className: utils['font-weight-medium'] }, text.FORM.RAADGIVNING_FATCA.OPEN_MODAL.no),
                React.createElement(NavigationButtons, { onPrevious: () => {
                        dispatchAnswers(flatMapAnswers(answers));
                        history.push(RoutePath.ANBEFALT_PROFIL);
                    } }))))),
        React.createElement(AutomatiskeProsesserModal, { visible: showModal, onClose: () => setShowModal(false) })));
};
const QuestionSection = ({ label, description, questions, control, answers, updateAnswer, initialAnswerState, }) => {
    const isBasedOnPreviousRaadgivning = initialAnswerState === AnswerState.ANSWERED;
    const [editable, setEditable] = useState(!isBasedOnPreviousRaadgivning);
    const allQuestions = sortQuestionsByPriority(questions);
    const titleSize = isBasedOnPreviousRaadgivning ? 'h4' : 'h3';
    return (React.createElement("div", null,
        React.createElement("div", { className: styles.sectionHeader },
            React.createElement(Title, { tag: "h2", size: titleSize }, label),
            React.createElement(Text, null, description)),
        React.createElement(Spacer, { child: 'md' },
            filterQuestions(allQuestions).map((question) => (React.createElement(RaadgivningInput, { key: question.id, question: question, answers: answers[question.id], updateAnswer: updateAnswer, editable: editable, control: control }))),
            hasOtherTaxRelation(allQuestions, answers) && (React.createElement(TaxRelationSection, { answers: answers, questions: allQuestions, updateAnswer: updateAnswer, control: control, editable: editable })),
            !editable && (React.createElement(SecondaryButton, { icon: React.createElement(Edit, null), onClick: () => setEditable(!editable), noPadding: true }, text.FORM.RAADGIVNING_FATCA.CHANGE_ANSWER(label).no)))));
};
const filterQuestions = (questions) => {
    return questions.filter((question) => showQuestion(question));
};
const sortQuestionsByPriority = (questions) => {
    return questions.sort((a, b) => a.priority - b.priority);
};
const sortGroupsByPriority = (groups) => {
    return groups.sort((a, b) => a.priority - b.priority);
};
const showQuestion = (question) => {
    return !(question.key === FatcaQuestionKey.VELG_SKATTEPLIKTIG_LAND ||
        question.key === FatcaQuestionKey.SKATTENUMMER ||
        question.key === FatcaQuestionKey.VELG_SKATTEPLIKTIG_LAND_2 ||
        question.key === FatcaQuestionKey.SKATTENUMMER_2);
};
